<template>
    <div :class="classNames">
        <div :class="classNames+ '_search'">
            <el-button type="primary" @click="createSystemFun">添加人员</el-button>
            <div :class="classNames+ '_search_con'">
                <div :class="classNames+ '_search_con_item'">
                    <el-input placeholder="请输入姓名" v-model="searchObj.name" class="input-with-select">
                    </el-input>
                </div>
                 <div :class="classNames+ '_search_con_item'">
                    <el-input placeholder="请输入账号" v-model="searchObj.account" class="input-with-select">
                    </el-input>
                </div>
                <div :class="classNames+ '_search_con_item'">
                    <el-button  type="primary"  @click="search">查询</el-button>
                </div>
            </div>
        </div>
        <div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="accountList.data"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width">
						<template slot-scope="scope">
							<div> {{scope.row[item.prop]}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
                            <span @click="edit(scope.row, 'editSystem')" :class="classNames+'_operation_title'">权限设置</span>
                            <span @click="edit(scope.row, 'editSystemInfo')" :class="classNames+'_operation_title'">编辑</span>
							<span @click="deltes(scope.row)" :class="classNames+'_operation_title'">{{scope.row.status == 1 ? '停用': '启用'}}</span>
                            <template v-if="scope.row.status == 2">
                                <el-popconfirm
                                :title="'确定删除账号‘'+scope.row.name+'’吗？'"
                                @confirm="deleteAccount(scope.row)"
                                >
                                <span slot="reference">
                                    <span  :class="classNames+'_operation_title'">删除</span>
                                </span>
                                </el-popconfirm>
                            </template>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="accountList.total" ref="pagination" v-model="searchObj.page" v-if="Math.ceil(accountList.total / accountList.limit) > 1"></Pagination>
		</div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import Pagination from '@/components/pagination/pagination.vue'
export default {
    data() {
        return {
            classNames: 'system',
            searchObj: {
                name: '',
                account: '',
                limit: 10,
                page: 1
            },
            headerList: [
               {
					prop: 'name',
					label: '姓名'
				},
				{
					prop: 'account',
					label: '账号'
				},
				{
					prop: 'created_time',
					label: '创建时间'
				}
            ],
            accountList: {
                data: [],
                total: 0
            },
            noDataName: 'empty',
        }
    },
    created() {
        this.getAccountListFun()
    },
    components: {
        Pagination
    },
    methods: {
        ...mapActions('permission', ['getAccountList', 'enableAccount','accountDel']),
        createSystemFun() {
            this.$router.push(this.staticPath + 'createSystem')
        },
        changeSize(size) {
            this.searchObj.page = size
            this.getAccountListFun()
        },
        async getAccountListFun(flag) {
            if(flag) {
                this.searchObj.page = 1
            }
            let res = await this.getAccountList(this.searchObj)
            this.accountList = res
        },
        edit(row, path) {
            this.$router.push(this.staticPath + path+ '/' + row.id)
        },
        async deltes(row) {
            await this.enableAccount({ id: row.id })
            this.$set(row, 'status', row.status == 1 ? 2 : 1)
            this.$message({
                type: 'success',
                message: (row.status == 2 ? '停用': '启用') + '成功'
            })
        },
        async deleteAccount(row){
            await this.accountDel({ id: row.id })
            this.$message({
                type: 'success',
                message: '删除成功'
            })
            this.search()
        },
        search() {
            this.noDataName = 'noData'
            this.getAccountListFun(true)
        }
    }
}
</script>
<style lang="less">
@classNames: system;
.@{classNames}_operation_title {
    margin-right: 12px;
    color: #1989FA;
    font-size: 14px;
    cursor: pointer;
}
</style>
<style lang="less" scoped>
    @classNames: system;
    .@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
        .el-table::before {
			background-color: transparent;
		}
		.@{classNames}_search {
			display: flex;
			justify-content: space-between;
			margin-bottom: 40px;
			flex-shrink: 0;

			.@{classNames}_search_con {
				display: flex;

				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}
		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
		}
	}
</style>
